<template>
    <el-dialog class="peiso-modal cashup-modal peiso-flex-modal" 
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    :close-on-click-modal='true'
    :close-on-press-escape="true"
    :before-close="handleClose"
    width="1028px"
    center>
        <div class="cashup-modal-container">
            <div class="header-container">
                <span>
                     CASH UP AND BANKING
                </span>

            </div>

            <div class="cashup-content d-flex flex-column gap-16">

                <div class="d-flex gap-16 cashup-content-flex">
                    <div class="cashupcontainer w-100 px-10">
                        <div class="wrapper">
                            <div class="safe-counts">
                                <div class="header d-flex align-items-center gap-16 text-center">
                                    <div class="w-100">Safe Count</div>
                                    <div class="w-100">Open</div>
                                    <div class="w-100">Close</div>
                                </div>

                                <div class="d-flex flex-column gap-5">
                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$100.00</div>
                                        <el-input v-model="opening.oneHundred" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.oneHundred" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>
                                    
                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$50.00</div>
                                        <el-input v-model="opening.fifty" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.fifty" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$20.00</div>
                                        <el-input v-model="opening.twenty" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.twenty" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$10.00</div>
                                        <el-input v-model="opening.ten" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.ten" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$5.00</div>
                                        <el-input v-model="opening.five" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.five" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$2.00</div>
                                        <el-input v-model="opening.two" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.two" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$1.00</div>
                                        <el-input v-model="opening.one" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.one" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$0.50</div>
                                        <el-input v-model="opening.fiftyCents" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.fiftyCents" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$0.20</div>
                                        <el-input v-model="opening.twentyCents" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.twentyCents" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">$0.10</div>
                                        <el-input v-model="opening.tenCents" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.tenCents" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>
                                    
                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">Total<br>Breakdown</div>
                                        <el-input v-model="totalOpenBreakDown" type="text" class="peiso-input-default w-100" :readonly="true"></el-input>
                                        <el-input v-model="totalCloseBreakDown" type="text" class="peiso-input-default w-100" :readonly="true"></el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="summary">
                                <div class="d-flex flex-column gap-5">
                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">Petty Cash</div>
                                        <el-input v-model="opening.pettyCash" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.pettyCash" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>
                                    
                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">Tills</div>
                                        <el-input v-model="opening.tills" type="number" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.tills" type="number" class="peiso-input-default w-100"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">Total</div>
                                        <el-input v-model="openingPettyCashTills" type="text" class="peiso-input-default w-100" :readonly="true"></el-input>
                                        <el-input v-model="closingPettyCashTills" type="text" class="peiso-input-default w-100" :readonly="true"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">Variance</div>
                                        <el-input v-model="openingVariance" type="text" class="peiso-input-default w-100" :readonly="true"></el-input>
                                        <el-input v-model="closingVariance" type="text" class="peiso-input-default w-100" :readonly="true"></el-input>
                                    </div>

                                    <div class="cashup-body d-flex align-items-center gap-16 text-center">
                                        <div class="w-100">Initial</div>
                                        <el-input v-model="opening.initial" type="text" class="peiso-input-default w-100"></el-input>
                                        <el-input v-model="closing.initial" type="text" class="peiso-input-default w-100"></el-input>
                                    </div>

                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div class="cashupcontainer w-100 px-10 banking">
                        <div class="wrapper">
                            <div class="banking">
                                <div class="header d-flex align-items-center gap-16 text-center">
                                    <div class="w-100">Banking</div>
                                    <div class="w-100"></div>
                                    <div class="w-100"></div>
                                </div>

                                <div class="d-flex flex-column">
                                    <div class="banking-container banking-header row d-flex align-items-center text-center">
                                        <div class="column p-10-all w-100 d-flex align-items-center justify-content-center">
                                            Tag number
                                        </div>
                                        <div class="column p-10-all w-100 d-flex align-items-center justify-content-center">
                                            Amount
                                        </div>
                                        <div class="column p-10-all" style="min-width: 67px !important;">
                                            
                                        </div>
                                    </div>

                                    <div class="banking-container row d-flex align-items-center text-center" v-for="(item, i) in banking" :key="`banking-${i}`">
                                        <div class="column p-10-all w-100 d-flex align-items-center justify-content-center">
                                            {{ item.tagNumber }}
                                        </div>
                                        <div class="column p-10-all w-100 d-flex align-items-center justify-content-center">
                                            {{ $box.formatMoney5(parseFloat(item.amount)) }}
                                        </div>
                                        <div class="column p-10-all">
                                            <el-button type="peiso-danger" @click="removeBanking(i)">-</el-button>
                                        </div>
                                    </div>

                                    <div class="banking-container d-flex align-items-center text-center">
                                        <div class="column p-10-all w-100">
                                            <el-input v-model="tagNumber" type="text" class="p-10 peiso-input-default w-100"></el-input>
                                        </div>
                                        <div class="column p-10-all w-100">
                                            <el-input v-model="amount" type="number" class="p-10 peiso-input-default w-100"></el-input>
                                        </div>
                                        <div class="column p-10-all">
                                            <el-button type="peiso-success" :disabled="isAllowedSaving" @click="saveBanking()">+</el-button>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
        <div class="d-flex align-items-center justify-content-center m-top-1rem cashup-content-flex">
            <el-button type="peiso-primary-pink-border-only" :disabled="isLoading" class="m-top-1rem" @click="saveCashupBanking(0)">SAVE AND EXIT</el-button>
            <!-- <el-button v-if="isLoading" type="peiso-primary-pink-border-only" class="m-top-1rem cursor-disable">SAVING...</el-button> -->
            <el-button type="peiso-primary-pink-border-only" class="m-top-1rem" :disabled="isLoading" @click="saveCashupBanking(1)">SAVE AND SEND EMAIL</el-button>
        </div>
    </el-dialog>
</template>

<style lang='scss'>
@import 'static/scss/fonts/fonts';
@import 'static/scss/colors';
@import 'static/scss/scrollbar';

.cashup-modal {
    .cashup-modal-container {
        height: 100%;
        overflow: hidden auto;
        
        &::-webkit-scrollbar {
            @extend .scrollbar;
        }

        &::-webkit-scrollbar-track {
            @extend .scrollbar-track-transparent;
        }

        &::-webkit-scrollbar-thumb {
            @extend .scrollbar-thumb-dark;
        }
        .cashup-content {
            
            .wrapper {
                
            }
    
            .header, .cashup-body {
                @include montserrat-font(16px, 153.9%, 500, $white) {
                    height: 45px;
                }
    
            }
    
            .header {
                margin-bottom: 1.5rem;
                border-bottom: 1px solid var(--text-color);
            }
    
            .summary {
                margin-top: 1.5rem;
                border-top: 1px solid var(--text-color);
                padding-top: 1.5rem;
            }
            
            .peiso-input-default {
                .el-input__inner {
                    text-align: center;
                    height: 45px !important;
                }
            }
    
            .banking-container {
                .el-button {
                    &--peiso-success, &--peiso-danger {
                        width: 45px;
                        height: 45px;
                    }
                }
    
                .column {
                    @include montserrat-font(16px, 153.9%, 500, $white) {
                        border: 1px solid $gray5;
                        min-height: 67px;
                    }
                }
    
                &.row {
                    
                }
    
                &.banking-header {
                    .column {
                        max-height: 45px !important;
                        min-height: 45px;
                    }
                }
            }
    
            

        }
    }
    .el-button {
        &--peiso-primary-pink-border-only {
            width: 300px;
        }
    }
}

    

</style>

<script>
import api from "@/api/api";
    export default {
        data() {
            return {
                isOpen: false,
                opening: {
                    oneHundred: null,
                    fifty: null,
                    twenty: null,
                    ten: null,
                    five: null,
                    two: null,
                    one: null,
                    fiftyCents: null,
                    twentyCents: null,
                    tenCents: null,

                    pettyCash: null,
                    tills: null,
                    initial: null,
                },
                closing: {
                    oneHundred: null,
                    fifty: null,
                    twenty: null,
                    ten: null,
                    five: null,
                    two: null,
                    one: null,
                    fiftyCents: null,
                    twentyCents: null,
                    tenCents: null,

                    pettyCash: null,
                    tills: null,
                    initial: null,
                },
                banking: [],
                tagNumber: '',
                amount: '',
                isLoading: false,
                isSend: false
            }
        },
        props: {
            open: {
                default: false  
            },

            timeZone: {
                default: null
            },

            currentWeek: {
                default: null
            },

            dailyTrendDay: {
                default: null
            }
        },
        watch: {
            open(val) {
                this.isOpen = val

                if (val) {
                    this.getCashUp()
                }
            },

        },
        computed: {
            totalOpenBreakDown() {
                var sum = this.opening
                
                var totalAll = this.breakdownTotalCalculator(sum)
                
                return Utils.formatMoney5(totalAll) 
            },
            totalCloseBreakDown() {
                var sum = this.closing
                
                var totalAll = this.breakdownTotalCalculator(sum)
                
                return Utils.formatMoney5(totalAll) 
            },

            openingPettyCashTills() {
                var total = this.pettyCashTillCalculation(this.opening)

                return Utils.formatMoney5(total)
            },

            closingPettyCashTills() {
                var total = this.pettyCashTillCalculation(this.closing)

                return Utils.formatMoney5(total)
            },

            openingVariance() {
                var sum = this.opening
                var total = this.pettyCashTillCalculation(sum) - this.breakdownTotalCalculator(sum)
                return Utils.formatMoney5(total)
            },

            closingVariance() {
                var sum = this.closing
                var total = this.pettyCashTillCalculation(sum) - this.breakdownTotalCalculator(sum)
                return Utils.formatMoney5(total)
            },

            isAllowedSaving() {
                if (this.tagNumber == '' || this.amount == '') {
                    return true
                } else {
                    return false
                }
            }

        },
        methods: {
            
            handleClose() {
                this.isOpen = false
                this.$emit('close-modal')
            },

            breakdownTotalCalculator(sum) {
                var tot = {}
                tot.one = Utils.nullToZero(sum.oneHundred) * 100.00
                tot.two = Utils.nullToZero(sum.fifty) * 50.00
                tot.three = Utils.nullToZero(sum.twenty) * 20.00
                tot.four = Utils.nullToZero(sum.ten) * 10.00
                tot.five = Utils.nullToZero(sum.five) * 5.00
                tot.six = Utils.nullToZero(sum.two) * 2.00
                tot.seven = Utils.nullToZero(sum.one) * 1.00
                tot.eight = Utils.nullToZero(sum.fiftyCents) * 0.50
                tot.nine = Utils.nullToZero(sum.twentyCents) * 0.20
                tot.ten = Utils.nullToZero(sum.tenCents) * 0.10

                var totalAll = Utils.calculateSum(tot)

                return totalAll
            },

            pettyCashTillCalculation(sum) {
                return Utils.nullToZero(parseFloat(sum.pettyCash)) + Utils.nullToZero(parseFloat(sum.tills))
            },

            saveBanking() {
                var banking = this.banking ? this.banking : []

                banking.push({
                    tagNumber: this.tagNumber,
                    amount: this.amount
                })

                this.banking = banking

                this.tagNumber = ''
                this.amount = ''
            },

            removeBanking(e) {
                this.banking.splice(e, 1)
            },

            saveCashupBanking(isSend) {
                this.opening.pettyCash = parseFloat(this.opening.pettyCash) ? this.opening.pettyCash : 0
                this.closing.pettyCash = parseFloat(this.closing.pettyCash) ? this.closing.pettyCash : 0
                this.opening.tills = parseFloat(this.opening.tills) ? this.opening.tills : 0
                this.closing.tills = parseFloat(this.closing.tills) ? this.closing.tills : 0

                var banking = this.banking ? this.banking : []
                
                banking = banking.map((n) => {
                        return {
                            tagNumber: n.tagNumber,
                            amount: n.amount
                        }
                    })

                var data = {
                    opening: this.opening,
                    closing: this.closing,
                    banking: banking,
                    report_date: Utils.getCurrentDate(this.currentWeek, this.dailyTrendDay, this.timeZone),
                }
                this.isLoading = true
                this.isSend = isSend
                api.cashRegister(data, this.isSend).then((res) => {
                    
                    var result = res.data
                    if (result.code == 0) {
                        Utils.alert2('', 'Cash up and banking data successfully saved', 'success')
                    } else {
                        Utils.alert2('', data.message, 'error')
                    }
                    this.isLoading = false
                    if (!this.isSend) {
                        this.handleClose()
                    }
                })
            },

            getCashUp() {
                // var date = Utils.dateTimeGeneratorWithDay(new Date(), this.timeZone, 'yyyy-MM-DD')
                var date = Utils.getCurrentDate(this.currentWeek, this.dailyTrendDay, this.timeZone)
                
                api.get_cashup(date).then((res) => {
                    var data = res.data
                    var banking = data.data.banking
                    

                    if (data.code == 0) {
                        this.banking = banking
                        if (data.data.cashRegisterData) {
                            var cashRegisterData = data.data.cashRegisterData
                            this.opening.oneHundred = Utils.checkValueExists(cashRegisterData.openingOneHundred) ? cashRegisterData.openingOneHundred : ''
                            this.opening.fifty = Utils.checkValueExists(cashRegisterData.openingFifty) ? cashRegisterData.openingFifty : ''
                            this.opening.twenty = Utils.checkValueExists(cashRegisterData.openingTwenty) ? cashRegisterData.openingTwenty : ''
                            this.opening.ten = Utils.checkValueExists(cashRegisterData.openingTen) ? cashRegisterData.openingTen : ''
                            this.opening.five = Utils.checkValueExists(cashRegisterData.openingFive) ? cashRegisterData.openingFive : ''
                            this.opening.two = Utils.checkValueExists(cashRegisterData.openingTwo) ? cashRegisterData.openingTwo : ''
                            this.opening.one = Utils.checkValueExists(cashRegisterData.openingOne) ? cashRegisterData.openingOne : ''
                            this.opening.fiftyCents = Utils.checkValueExists(cashRegisterData.openingFiftyCents) ? cashRegisterData.openingFiftyCents : ''
                            this.opening.twentyCents = Utils.checkValueExists(cashRegisterData.openingTwentyCents) ? cashRegisterData.openingTwentyCents : ''
                            this.opening.tenCents = Utils.checkValueExists(cashRegisterData.openingTenCents) ? cashRegisterData.openingTenCents : ''
    
                            this.opening.pettyCash = Utils.checkValueExists(cashRegisterData.openingPettyCash) ? cashRegisterData.openingPettyCash : 0
                            this.opening.tills = Utils.checkValueExists(cashRegisterData.openingTills) ? cashRegisterData.openingTills : 0
                            this.opening.initial = Utils.checkValueExists(cashRegisterData.openingInitial) ? cashRegisterData.openingInitial : ''
    
                            this.closing.oneHundred = Utils.checkValueExists(cashRegisterData.closingOneHundred) ? cashRegisterData.closingOneHundred : ''
                            this.closing.fifty = Utils.checkValueExists(cashRegisterData.closingFifty) ? cashRegisterData.closingFifty : ''
                            this.closing.twenty = Utils.checkValueExists(cashRegisterData.closingTwenty) ? cashRegisterData.closingTwenty : ''
                            this.closing.ten = Utils.checkValueExists(cashRegisterData.closingTen) ? cashRegisterData.closingTen : ''
                            this.closing.five = Utils.checkValueExists(cashRegisterData.closingFive) ? cashRegisterData.closingFive : ''
                            this.closing.two = Utils.checkValueExists(cashRegisterData.closingTwo) ? cashRegisterData.closingTwo : ''
                            this.closing.one = Utils.checkValueExists(cashRegisterData.closingOne) ? cashRegisterData.closingOne : ''
                            this.closing.fiftyCents = Utils.checkValueExists(cashRegisterData.closingFiftyCents) ? cashRegisterData.closingFiftyCents : ''
                            this.closing.twentyCents = Utils.checkValueExists(cashRegisterData.closingTwentyCents) ? cashRegisterData.closingTwentyCents : ''
                            this.closing.tenCents = Utils.checkValueExists(cashRegisterData.closingTenCents) ? cashRegisterData.closingTenCents : ''
    
                            this.closing.pettyCash = Utils.checkValueExists(cashRegisterData.closingPettyCash) ? cashRegisterData.closingPettyCash : 0
                            this.closing.tills = Utils.checkValueExists(cashRegisterData.closingTills) ? cashRegisterData.closingTills : 0
                            this.closing.initial = Utils.checkValueExists(cashRegisterData.closingInitial) ? cashRegisterData.closingInitial : ''
                        } else {
                            this.clearFields()
                        }
                    } else {
                        Utils.alert2('', 'Error on retrieving data', 'error')
                    }
                })
            },

            clearFields() {
                this.opening.oneHundred = ''
                this.opening.fifty = ''
                this.opening.twenty = ''
                this.opening.ten = ''
                this.opening.five = ''
                this.opening.two = ''
                this.opening.one = ''
                this.opening.fiftyCents = ''
                this.opening.twentyCents = ''
                this.opening.tenCents = ''

                this.opening.pettyCash = 0
                this.opening.tills = 0
                this.opening.initial = ''

                this.closing.oneHundred = ''
                this.closing.fifty = ''
                this.closing.twenty = ''
                this.closing.ten = ''
                this.closing.five = ''
                this.closing.two = ''
                this.closing.one = ''
                this.closing.fiftyCents = ''
                this.closing.twentyCents = ''
                this.closing.tenCents = ''

                this.closing.pettyCash = 0
                this.closing.tills = 0
                this.closing.initial = ''
            }

        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/cashupBanking.vue